import StarPool from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_TESTNET/StarPool.json';
import StarReward from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_TESTNET/StarReward.json';
import StarTier from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_TESTNET/StarTier.json';
import StarChallenge from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_TESTNET/StarChallenge.json';
import StarPoint from '../../../contracts-upgradeable/deployments/ARBITRUM_V2_TESTNET/StarPoint.json';
import StarStaking from '../../../contracts/deployments/HOLESKY_V2_TESTNET/StarOFTokenLock.json';
import StarOFToken from '../../../contracts/deployments/HOLESKY_V2_TESTNET/StarOFToken.json';

export const environment = {
  passkeyEnabled: false,
  production: false,
  cognitoClientId: '2ccv2f7ai0f6eavtrsmgv22vfj',
  reownProjectId: '70638f0963b753fa034452313c84da67',
  apiUrl: `https://api-stage.sponstar.io/`,
  siteUrl: `https://www-stage.sponstar.io/`,
  assetsUrl: `https://www-stage.sponstar.io/`,
  googleClientId: '21768675305-iqd9ug8coh8c3gpg5e8vv8lkspg8pgcd.apps.googleusercontent.com',
  authGoogle: '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',
  gatewayUrl: 'https://ms-stage.sponstar.io/',
  rpcAddress: 'https://arb-sepolia.g.alchemy.com/v2/S7YIYn4BsINlC4U3oWl0Htm_Ia4OGmOF',
  blockExplorerUrl: `https://sepolia.arbiscan.io/`,
  alchemyApiKey: 'S7YIYn4BsINlC4U3oWl0Htm_Ia4OGmOF',
  alchemyPolicyId: 'd8f925f7-03ad-4b04-9c3d-5fc2d17858ce',
  zeroDev: {
    projectId: '7712e055-2d8e-41e5-bf62-efe757735fa8',
    rpcUrl: 'https://rpc.zerodev.app/api/v3/7712e055-2d8e-41e5-bf62-efe757735fa8/chain/421614',
    passkeyServer: 'https://passkeys.zerodev.app/api/v3/7712e055-2d8e-41e5-bf62-efe757735fa8',
  },
  contracts: {
    StarPool: { abi: StarPool.abi, address: StarPool.address },
    StarReward: { abi: StarReward.abi, address: StarReward.address },
    StarTier: { abi: StarTier.abi, address: StarTier.address },
    StarChallenge: { abi: StarChallenge.abi, address: StarChallenge.address },
    StarPoint: { abi: StarPoint.abi, address: StarPoint.address },
    StarStaking: { abi: StarStaking.abi, address: StarStaking.address },
    StarOFToken: { abi: StarOFToken.abi, address: StarOFToken.address },
  },
};
